import {RemoteGetCityLocation} from 'data/usecases/private/booking-flow/health/remote-get-city-location';
import {GetCityLocation} from 'domain/usecases/private/booking-flow/health/get-city-location';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetCityLocation = (): GetCityLocation =>
	new RemoteGetCityLocation(
		makeBFFApiUrl(BookingFlowEndPoints.cityLocation),
		makeAuthorizeHttpClientDecorator(),
	);

export const makeMockedGetCityLocation = (): GetCityLocation => ({
	get: async () => ({
		content: {
			city: {
				name: 'Fortaleza',
				uf: 'CE',
				state: 'Ceara',
			},
		},
		traceId: '1dd9890459698d995aa4d267de777a38',
		notifications: [],
	}),
});

export const makeMockedErrorGetCityLocation = (): GetCityLocation => ({
	get: async () => {
		throw new Error('Error fetching city location');
	},
});
